import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  DollarSign,
  MessageSquareMore,
  IdCard,
  IndianRupee,
} from "lucide-react";

interface ProductsViewProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProductsView = ({ isOpen, onClose }: ProductsViewProps) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const products = [
    // {
    //   title: "Payroll",
    //   description:
    //     "Comprehensive payroll management with automated tax compliance and employee self-service.",
    //   icon: DollarSign,
    //   href: "/products/payroll",
    // },
    {
      title: "Payroll",
      description:
        "simplify HR while  empowering teams and ensuring compliance.",
      icon: IndianRupee,
      href: "/products/Payroll",
    },
    {
      title: "Communication Tool",
      description:
        "Unified internal communication platform for messaging, announcements, and collaboration.",
      icon: MessageSquareMore,
      href: "/products/communicationTool",
    },
    {
      title: "Modern Hiering",
      description:
        "Unified internal communication platform for messaging, announcements, and collaboration.",
      icon: IdCard,
      href: "/products/ModernHiering",
    },
  ];

  const handleProductClick = (href: string) => {
    navigate(href);
    onClose();
  };

  return (
    <div
      ref={menuRef}
      className="fixed top-16 left-0 right-0 bg-background/95 backdrop-blur-sm border-b border-border shadow-xl z-[60]"
      onMouseEnter={() => {}}
      onMouseLeave={onClose}
    >
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Header */}
        <div className="mb-6">
          <h3 className="text-lg font-bold text-foreground mb-1">
            Our Products
          </h3>
        </div>

        {/* Mobile Layout */}
        <div className="block md:hidden">
          <div className="grid grid-cols-1 gap-4 max-h-[60vh] overflow-y-auto">
            {products.map((product, index) => (
              <button
                key={index}
                onClick={() => handleProductClick(product.href)}
                className="w-full group text-left px-3 py-3 text-sm text-foreground hover:text-orange-600 hover:bg-orange-50/50 transition-all duration-200 rounded-md border border-transparent hover:border-orange-200/50 flex items-start gap-3"
              >
                <product.icon className="h-4 w-4 text-orange-500 flex-shrink-0 mt-1" />
                <div>
                  <div className="font-medium text-sm leading-tight group-hover:text-orange-600 transition-colors">
                    {product.title}
                  </div>
                  <div className="text-xs text-muted-foreground mt-1 leading-tight">
                    {product.description}
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <div key={index} className="h-full flex flex-col">
              <button
                onClick={() => handleProductClick(product.href)}
                className="w-full h-full group text-left px-3 py-4 text-sm text-foreground hover:text-orange-600 hover:bg-orange-50/50 transition-all duration-200 rounded-md border border-transparent hover:border-orange-200/50"
              >
                <div className="flex items-center gap-3 mb-2">
                  <product.icon className="h-5 w-5 text-orange-500 flex-shrink-0" />
                  <div className="font-medium text-sm leading-tight group-hover:text-orange-600 transition-colors">
                    {product.title}
                  </div>
                </div>
                {/* <div className="text-xs text-muted-foreground leading-tight pl-8">
                  {product.description}
                </div> */}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsView;
